import React from 'react'
import { Icon } from '@iconify/react'

export default function NotaFiscal() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: '600px',
      padding: '24px',
      textAlign: 'center',
      color: '#64748b'
    }}>
      <div style={{
        width: '120px',
        height: '120px',
        backgroundColor: '#f1f5f9',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px'
      }}>
        <Icon icon="ph:receipt" width="64" color="#94a3b8" />
      </div>
      
      <h1 style={{ 
        fontSize: '28px', 
        fontWeight: '700', 
        color: '#1e293b', 
        marginBottom: '12px' 
      }}>
        Em breve: Notas Fiscais
      </h1>
      
      <p style={{ 
        fontSize: '16px', 
        maxWidth: '500px', 
        lineHeight: '1.6',
        marginBottom: '32px' 
      }}>
        Estamos trabalhando duro para trazer a emissão automática de notas fiscais para o sistema.
        Você será notificado assim que esta funcionalidade estiver disponível.
      </p>

      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#f0fdf4',
        color: '#166534',
        borderRadius: '20px',
        fontSize: '14px',
        fontWeight: '600',
        border: '1px solid #bbf7d0'
      }}>
        <Icon icon="ph:clock-countdown" width="18" />
        Lançamento previsto para o próximo trimestre
      </div>
    </div>
  )
}
